export default {
    artifacts: {
        title: 'Артефакты',
        subtitle: 'Раздел артефакты',

        artifact: 'Артефакты',
        type: 'Типы артефактов',
        document: 'Типы документов',
        tag: 'Тэги',
        occasion: 'Ассоциации',
        country: 'Страны',
        century: 'Века',
        value: 'Типы стоимости',
        unit: 'Единицы измерения',
        valuation: 'Оценка артефактов',
        violation_reports: 'Жалобы',
        brain_health: 'Brain health study',
    },
    companies: {
        title: 'Companies',
        subtitle: 'Companies section',

        companies: 'Companies',
        request: 'Companies requests',
        forProfessionals: 'For Professionals page',
    },
    marketing: {
        title: 'Маркетинг',
        subtitle: 'Раздел маркетинга',

        promo_code: 'Внутренние промокоды',
        partner_promo_code: 'Партнерские промокоды',
        qr_code: 'QR коды',
    },
    subscriptions: {
        title: 'Подписка',
        subtitle: 'Раздел подписки',

        plan: 'Тарифные планы',
        plan_description: 'Описание тарифов',
        plan_permission: 'Разрешения тарифов',
        subscription: 'Подписки пользователей',
        subscription_gift: 'Подарочные подписки',
        transaction: 'Платежи',

        concierge_service: 'Консьерж сервис',

        artiProMembership: 'Подписки ARTIPro',
    },
    blog: {
        title: 'Блог',
        subtitle: 'Раздел блога',

        category: 'Категории постов',
        post: 'Посты',
    },
    users: {
        title: 'Пользователи',
        subtitle: 'Раздел пользователи',

        user: 'Пользователи',

        sharing_list: 'Общие списки',
        circle_list: 'Круги',

        email_subscriptions_list: 'Email подписки',
    },
    administrators: {
        title: 'Администраторы',
        subtitle: 'Раздел администраторы',

        administrator: 'Администраторы',
        permissions: 'Разрешения',
        roles: 'Роли',
    },
    content: {
        title: 'Контент',
        subtitle: 'Раздел контент',

        content: 'Контент',
    },
    homepage: {
        title: 'Главная',
        subtitle: 'Главная страница',

        homepage: 'Главная страница',
    },
    pages: {
        title: 'Страницы',
        subtitle: 'Страницы',
    },
    faq: {
        title: 'FAQ',
    },
    forMom: {
        title: 'For Mom',
    },
    artiPro: {
        title: 'Arti Pro',
    },
    komen: {
        title: 'Komen page',
    },
}
